var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0 ma-md-2"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-text',[(_vm.organization)?_c('scheduler-calendar',{attrs:{"scope":"org","can-edit":_vm.canEdit}}):_vm._e()],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }